// The browser end of navigationRecovery.ts: the real Sentry, the real
// Notify, the real page load. Lifted from go-schedule's
// src/lib/navigationErrorHandler.ts.
//
// Kept apart from the handler itself so that installing the handler can be
// tested against a real router in Node, without dragging the browser SDK and
// Quasar's plugin registry into the test.
import * as Sentry from '@sentry/vue'
import { Notify } from 'quasar'
import { sessionReloadMemory, type NavigationErrorDeps } from './navigationRecovery'

export function browserNavigationErrorDeps(): NavigationErrorDeps {
  return {
    memory: sessionReloadMemory(window.sessionStorage),
    now: () => Date.now(),
    reload: (href) => window.location.assign(href),
    report: (err) => {
      Sentry.captureException(err)
    },
    notify: (message) => Notify.create({ type: 'negative', message }),
  }
}
